import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { calculateScore } from ".";
import { matchingSelector } from ".";

function iterateRules(rules, element, scoresPool, property) {
  for (var ruleIdx in rules) {
    var rule = rules[ruleIdx];

    if (!(rule instanceof CSSStyleRule)) {
      continue;
    }

    try {
      if (matchingSelector(element, rule.selectorText)) {
        var style = rule.style[property];

        if (style !== undefined && style !== "") {
          scoresPool.push(_objectSpread(_objectSpread({}, calculateScore(rule, scoresPool.length, property)), {}, {
            style: style
          }));
        }
      }
    } catch (e) {// Silence is golden.
    }
  }
}

export { iterateRules };